import React, { useState }              from 'react';
import { historyPropType }              from '~/config/routerPropTypes';
import { newTourImage, showTourImage }  from '~/config/routes';
import Request                          from '~/providers/Request';
import TourImageRecord                  from '~/records/TourImageRecord';
import Form                             from './Form';

function NewRecord({history}){
  const [record, setRecord] = useState(new TourImageRecord());
  const [ loading, setLoading] = useState(false);

  async function onSubmit (saveAndContinue){
    let archive_id = record.get('archive_id') ? record.get('archive_id') : null;
    const imageBase64 = record.get('image_base64');
    setLoading(true);
    if(imageBase64){
      try {
        const result = await Request.post('/upload_base64', { file: `data:image/jpg;base64,${imageBase64}` });
        archive_id = result.data.id;
      } catch(e) {console.log(e);}
    }

    const data = record.toParams({archive_id});
    Request.post('/admin/tour_images', data, {}, { controller: 'tourImage' })
      .then((resp) => {
        setLoading(false);
        if(saveAndContinue){
          history.push(newTourImage.spec);
        } else{
          history.push(showTourImage.reverse(resp.data));
        }
      })
      .catch(e => {
        console.error(e);
        setLoading(false);
      });
  }

  const handleChange = (attrs) => {
    setRecord( record.updateAttributes(attrs) );
  };

  return(
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
    />
  );
}

NewRecord.propTypes={
  history: historyPropType,
};

export default NewRecord;
